var map = {
	"./gooroomee_study_download_image1.png": "./src/assets/images/camstudy/gooroomee_study_download_image1.png",
	"./gooroomee_study_download_image2.png": "./src/assets/images/camstudy/gooroomee_study_download_image2.png",
	"./gooroomee_study_download_image3.png": "./src/assets/images/camstudy/gooroomee_study_download_image3.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/camstudy sync recursive ^\\.\\/gooroomee_study_download_.*\\.png$";